import * as Yup from "yup";

export const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email format")
    .required("Enter your email!"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long")
    .required("Enter your password!"),
});
